import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Download(props) {
    return (
        <SvgIcon {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(0.000000, 7.000000)" fill="#000000">
                    <path d="M27,18.9619454 L37.5999895,8.57172461 L40.4000105,11.4282754 L24.7023554,26.8152814 L7.6624352,11.4869164 L10.3375648,8.51308359 L22,19.0040989 L22,0 L27,0 L27,18.9619454 Z" />
                    <polygon id="Path-3" fillRule="nonzero" points="42.9974881 12 48 12 48 35 0 35 0 12 5.0025119 12 5.0025119 30 42.9974881 30" />
                </g>
            </g>
        </SvgIcon>
    );
}

Download.defaultProps = {
    viewBox: '0 0 48 48'
};

export default Download;
